var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSymbol(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 40,
    viewBox: "0 0 80 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_61)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.0182 1.16531C62.1754 0.705319 62.6085 0 63.793 0H63.9003H78.1869C79.6818 0.0536655 79.9157 1.26114 79.9463 1.50264C79.1529 22.8654 61.5621 40 39.9732 40C18.3843 40 0.739818 22.8117 0 1.39914C0.0881648 0.988979 0.444658 0.030666 1.8323 0.030666C1.97413 0.030666 2.08912 0.0191663 2.18112 0H15.8275C15.9118 0.0114998 16.0115 0.0191663 16.1303 0.0191663C17.4336 0.0191663 17.8285 0.873982 17.9435 1.31481C18.6258 12.8759 28.1974 22.0719 39.977 22.0719C51.7566 22.0719 61.4087 12.7954 62.0182 1.16531Z",
    fill: "url(#paint0_linear_1_61)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_61",
    x1: 0.845922,
    y1: 19.3374,
    x2: 80.7923,
    y2: 19.3374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#29C9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#32B9FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#5977F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#714EEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#7B3FE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D413E5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_61"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 40,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbol);
export default __webpack_public_path__ + "static/media/Symbol.c19a1c806d0a64ceb9fbc85a6710b3ad.svg";
export { ForwardRef as ReactComponent };